<section #sectionContainer>
    @if(isModal) {
        <h2 mat-dialog-title class="dialog-title">{{ dialogTitle }}</h2>
    }
    @else if (applicationSectionEdit) {
        <div class="application-section-header">
            <h2 class="dialog-title">{{ dialogTitle }}</h2>
            <span class="editing-indicator">Editing</span>
            <div class="application-section-header-actions">
                <mrs-btn-tertiary class="close-btn" buttonId="close" [buttonLabel]="closeButtonLabel"
                    [disabled]="saving" (onClick)="handleClose()"></mrs-btn-tertiary>
                <mrs-btn-primary [buttonLabel]="saveButtonLabel" buttonId="saveDecision"
                    [disabled]="!canSave || saving || !interviewLoaded || !interviewManager.constantMapKeysLoaded || interviewManager.formattedSection.isLocked"
                    (onClick)="handleSave()"></mrs-btn-primary>
            </div>
        </div>
    }
    @else {
        <h2 class="dialog-title" style="padding-top: 10px">{{ dialogTitle }}</h2>
    }
    
    @if (isModal) {
        <mat-dialog-content *ngIf="!interviewLoaded || !interviewManager.constantMapKeysLoaded">
            <mat-spinner diameter="20"></mat-spinner>
        </mat-dialog-content>
    }

    <mat-dialog-content [id]="sectionContainerHtmlId"
        *ngIf="(interviewLoaded || (applicationSectionEdit && saving)) && interviewManager.constantMapKeysLoaded"
        [style.pointer-events]="saving ? 'none' : null">
        <third-party-section *ngIf="applicationSectionEdit && interviewManager.formattedSection.isThirdParty"
            [embeddedData]="interviewManager.formattedSection.embeddedIntegrationData" [isCaseSummary]="false">
        </third-party-section>
        <dynamic-form *ngIf="!applicationSectionEdit || !interviewManager.formattedSection.isThirdParty"
            [expandAllQuestions]="true"
            [selectedQuestion]="interviewManager.selectedQuestion"
            [interviewMode]="interviewManager.interviewMode"
            [parentIndex]=""
            [sectionLocked]="interviewManager.formattedSection.isLocked"
            [(constantLists)]="interviewManager.constantLists"
            [config]="interviewManager.formattedSection.questions"
            [formattedSection]="interviewManager.formattedSection">
        </dynamic-form>
    </mat-dialog-content>

    @if(isModal) {
    <mat-dialog-actions align="end" >
        <mrs-btn-tertiary class="close-btn" buttonId="close" [buttonLabel]="closeButtonLabel" [disabled]="saving" (onClick)="handleClose()"></mrs-btn-tertiary>
        <mrs-btn-primary [buttonLabel]="saveButtonLabel" buttonId="saveDecision"
            [disabled]="!canSave || saving || !interviewLoaded || !interviewManager.constantMapKeysLoaded || interviewManager.formattedSection.isLocked"
            (onClick)="handleSave()"></mrs-btn-primary>
    </mat-dialog-actions>
}
@else if (!applicationSectionEdit) {
    <div style="display: flex; padding-bottom: 50px;">
        <mrs-btn-tertiary class="close-btn" buttonId="close" [buttonLabel]="closeButtonLabel" [disabled]="saving" (onClick)="handleClose()"></mrs-btn-tertiary>
        <mrs-btn-primary [buttonLabel]="saveButtonLabel" buttonId="saveDecision"
            [disabled]="!canSave || saving || !interviewLoaded || !interviewManager.constantMapKeysLoaded || interviewManager.formattedSection.isLocked"
            (onClick)="handleSave()"></mrs-btn-primary>
    </div>
}
</section>